// extracted by mini-css-extract-plugin
module.exports = {"form":"productWithdrawalManagement_form__2FTq4","content":"productWithdrawalManagement_content__3iZI_","contentMain":"productWithdrawalManagement_contentMain__1RUBC"};